import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAudtiLogProvider } from '../AuditLog.Hooks';

export default function AuditLogList() {
  const { lang, translate } = getLocales();
  const { listApi, pageRouter } = useAudtiLogProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.changeLogs}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.user}</th>
          <th>{lang.application}</th>
          <th>{lang.permission}</th>
          <th>{lang.changedOn}</th>
          <th>{lang.entity}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: auditLog }) => (
            <tr key={auditLog.id}>
              <td>{auditLog.user?.fullName ?? 'N/A'}</td>
              <td>{auditLog.application?.name}</td>
              <td>{translate(auditLog.permissionKey)}</td>
              <td>{auditLog.changedAtUtcParsed}</td>
              <td>
                {auditLog.entityName}, ID: {auditLog?.currentEntity?.id}
              </td>
              <td>
                <Button
                  class={ThemeButtonCircle}
                  media={<Icon class="fas-info-circle" />}
                  onClick={pageRouter.updateParams}
                  data={{ id: auditLog.id.toString() }}
                  htmlElementProps={{ title: lang.info }}
                  active
                />
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
